import { render } from "./left-nav.component.vue?vue&type=template&id=bbb5aaf6&ts=true"
import script from "./left-nav.component.vue?vue&type=script&lang=ts"
export * from "./left-nav.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__